// extracted by mini-css-extract-plugin
export default {"container":"About_container__1M1PS","about":"About_about__362rG"};